import {useEffect, useRef} from "react";
import {useApi} from "./useApi";

// State + setter come from the dashboard's single useStorage instance rather
// than a useStorage call here: a second instance would write the shared
// sessionStorage key with its own stale copy of the other slice, clobbering
// the watch history saved by useWatchHistory (and vice versa).
const useActivity = ({user, activity, setActivity}) => {
  const {fetchActivity} = useApi();

  const activityRef = useRef(activity);

  useEffect(() => {
    activityRef.current = activity;
  }, [activity]);

  useEffect(() => {
    if (!user?.customer_id && !activity) return;

    fetchActivity(user.customer_id).then(setActivity);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return {activityRef};
};
export default useActivity;
